import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type Lang = "fr" | "en" | "ln";
export type Role = "investor" | "farmer" | "merchant" | "agent";

interface AppCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
  role: Role;
  setRole: (r: Role) => void;
}

const Ctx = createContext<AppCtx | null>(null);

export function AppProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  const [lang, setLangState] = useState<Lang>(
    (localStorage.getItem("mb_lang") as Lang) || "fr"
  );
  const [role, setRoleState] = useState<Role>(
    (localStorage.getItem("mb_role") as Role) || "investor"
  );

  useEffect(() => {
    i18n.changeLanguage(lang);
    localStorage.setItem("mb_lang", lang);
  }, [lang, i18n]);

  useEffect(() => {
    localStorage.setItem("mb_role", role);
  }, [role]);

  return (
    <Ctx.Provider
      value={{
        lang,
        setLang: setLangState,
        role,
        setRole: setRoleState,
      }}
    >
      {children}
    </Ctx.Provider>
  );
}

export function useApp() {
  const c = useContext(Ctx);
  if (!c) throw new Error("useApp must be used within AppProvider");
  return c;
}
